var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessingFactor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Processing_factor",
    "data-name": "Processing factor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.548,
    height: 13.641,
    viewBox: "0 0 17.548 13.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_86314",
    "data-name": "Path 86314",
    d: "M393,358h1.165v3.325H393Z",
    transform: "translate(-379.531 -347.684)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86315",
    "data-name": "Path 86315",
    d: "M17.034,241H.514a.514.514,0,0,0-.514.514v6.306a.514.514,0,0,0,.514.514H2.433v-1.645a.514.514,0,0,1,1.028,0v1.645H4.627v-1.645a.514.514,0,0,1,1.028,0v1.645H6.82v-1.645a.514.514,0,0,1,1.028,0v1.645H9.014v-1.645a.514.514,0,0,1,1.028,0v1.645h2.4V244.5a.514.514,0,0,1,.514-.514h2.193a.514.514,0,0,1,.514.514v3.839h1.371a.514.514,0,0,0,.514-.514v-6.306A.514.514,0,0,0,17.034,241Zm-7.506,4.01H2.947a.514.514,0,0,1,0-1.028h6.58a.514.514,0,0,1,0,1.028Z",
    transform: "translate(0 -234.694)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86316",
    "data-name": "Path 86316",
    d: "M351.793,165.441a.514.514,0,0,0-.509-.441H349.09a.514.514,0,0,0-.509.441l-.162,1.135h3.536Z",
    transform: "translate(-336.478 -161.299)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86317",
    "data-name": "Path 86317",
    d: "M214.829,57.464a.514.514,0,0,0-.512-.464h-1.851a.514.514,0,0,0-.512.464l-.075.77H214.9Z",
    transform: "translate(-204.618 -57)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86318",
    "data-name": "Path 86318",
    d: "M203.887,123h-3.225l-.294,3.016h3.813Z",
    transform: "translate(-193.501 -120.738)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86319",
    "data-name": "Path 86319",
    d: "M62.829,57.464A.514.514,0,0,0,62.318,57H60.467a.514.514,0,0,0-.512.464l-.075.77H62.9Z",
    transform: "translate(-57.828 -57)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86320",
    "data-name": "Path 86320",
    d: "M51.887,123H48.662l-.294,3.016h3.813Z",
    transform: "translate(-46.71 -120.738)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingFactor);
export default __webpack_public_path__ + "static/media/processing_factor.22f71f5bfffceb8913892e723939ea64.svg";
export { ForwardRef as ReactComponent };